<template>

    <vue-date-range-picker
        v-model="range"
        :locale-data="props"
        @update="onDateSelected"
    >
        <template #ranges="ranges">
            <div class="ranges">
                <ul>
                    <li v-for="(range, name) in customRanges" :key="name" @click="ranges.clickRange(range)">
                        <b>{{ customRangesTranslations[name] }}</b>
                    </li>
                </ul>
            </div>
        </template>
        <template v-slot:input="picker" style="min-width: 350px;">
            {{ displayedStartDate }} - {{ displayedEndDate }}
        </template>
    </vue-date-range-picker>

</template>

<script>
import VueDateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    name: "DateRangePicker",
    components: {VueDateRangePicker},
    data() {
        return {
            range: {
                startDate: null,
                endDate: null
            },
            props: {
                firstDay: 1,
                direction: 'ltr',
                format: 'DD/MM/YYYY',
                separator: ' - ',
                applyLabel: 'Appliquer',
                cancelLabel: 'Fermer',
                monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
            },
            customRanges: {
                today: null,
                last7days: null,
                last30days: null,
                thisMonth: null,
                lastMonth: null
            },
            customRangesTranslations: {
                today: "Aujourd'hui",
                last7days: "7 derniers jours",
                last30days: "30 derniers jours",
                thisMonth: "Ce mois",
                lastMonth: "Le mois dernier"
            },
            today: function () {
                const n = new Date();
                const endToday = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0);
                const startToday = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 23, 59);
                return [endToday, startToday];
            },
            last7days: function () {
                const n = new Date();
                const sevenDaysAgo = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 6);
                const startToday = new Date(n.getFullYear(), n.getMonth(), n.getDate());
                return [sevenDaysAgo, startToday]
            },
            last30days: function () {
                const n = new Date();
                const thirtyDaysAgo = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 29);
                const startToday = new Date(n.getFullYear(), n.getMonth(), n.getDate());
                return [thirtyDaysAgo, startToday]
            },
            thisMonth: function () {
                const n = new Date();
                const lastMonth = new Date(n.getFullYear(), n.getMonth(), 1);
                const thisMonth = new Date(n.getFullYear(), n.getMonth() + 1, 0);
                return [lastMonth, thisMonth]
            },
            lastMonth: function () {
                const n = new Date();
                const lastMonth = new Date(n.getFullYear(), n.getMonth() - 1, 1);
                const thisMonth = new Date(n.getFullYear(), n.getMonth(), 1,-1);
                return [lastMonth, thisMonth]
            },
        }
    },
    created() {
        this.customRanges.today = this.today();
        this.customRanges.last7days = this.last7days();
        this.customRanges.last30days = this.last30days();
        this.customRanges.thisMonth = this.thisMonth();
        this.customRanges.lastMonth = this.lastMonth();
    }
    ,
    computed: {
        displayedStartDate() {
            return moment(this.range.startDate).format('DD/MM/YYYY');
        }
        ,
        displayedEndDate() {
            return moment(this.range.endDate).format('DD/MM/YYYY');
        }
    },
    methods: {
        onDateSelected: function (range) {
            let start = moment(range.startDate).format('YYYY-MM-DD');
            let end = moment(range.endDate).format('YYYY-MM-DD');
            let date = moment(range.startDate).format('DD/MM/YYYY') + " - " + moment(range.endDate).format('DD/MM/YYYY');
            this.$parent.getDate(start, end, date);
        }
    },
}
</script>

<style>
    .vue-daterange-picker {
        width: 100% !important;
    }
    .daterangepicker .drp-selected {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/layout/DateRangePicker.vue